import { ProgressIndicatorService } from './progress-indicator.service';
import { SubscriptionHandler } from '../data/subscription-handler';
import { ApiResult } from 'idk/data/api-result';
import { Injectable } from '@angular/core';
import { PartialObserver } from 'rxjs';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { CommonDialogsService } from 'idk/widgets/common-dialogs/common-dialogs.service';
import { UserProfileService } from './security/user-profile.service';
import { Router } from '@angular/router';
@Injectable({
    providedIn: 'root',
})
export class ObservableWrapperService {
    public constructor(
        private _profile: UserProfileService,
        private _progress: ProgressIndicatorService,
        private _dialogs: CommonDialogsService,
        private _router: Router
    ) {}

    public subscribe<T>(
        observable: Observable<ApiResult<T>>,
        handler: SubscriptionHandler<T>
    ): void {
        if (handler.blocking) {
            const token = {};
            this._progress.show(token, true);

            observable
                .pipe(
                    finalize(() => {
                        this._progress.hide(token);
                    })
                )
                .subscribe(this.for<T>(handler));
        } else {
            observable.subscribe(this.for<T>(handler));
        }
    }

    public for<T>(
        handler: SubscriptionHandler<T>
    ): PartialObserver<ApiResult<T>> {
        return {
            next: (r: ApiResult<T>) => {
                try {
                    if (r.valid) {
                        handler.success(r);
                    } else {
                        // console.log(r);
                        if (r.code > 0) {
                            if (handler.warning) {
                                // Sin caer al finally, quien llama se quedaba con la pantalla
                                // bloqueada y sin recargar su listado: el contrato de finally es
                                // ejecutarse en cualquier caso, éxito o fracaso.
                                handler.warning(r);
                            } else {
                                this._dialogs.error(r.message);
                            }
                        } else {
                            const evt = {
                                response: r,
                                handled: false,
                            };
                            if (handler.error) {
                                handler.error(evt);
                                if (!evt.handled) {
                                    this._dialogs.error(r.message);
                                }
                            } else {
                                this._dialogs.error(r.message);
                            }
                        }
                    }
                } catch (e) {
                    console.error(e);
                    this._dialogs.error(
                        `Ocurrió un error no manejado en el control del proceso. ${e.message}`
                    );
                }

                if (handler.finally) {
                    handler.finally();
                }
            },
            error: (r: any) => {
                const evt = {
                    error: r,
                    handled: false,
                };
                if (handler.error) {
                    handler.error(evt);
                    if (!evt.handled) {
                        this._dialogs.error(r.message);
                    }
                } else {
                    switch (r.status) {
                        case 403:
                            this._router.navigateByUrl('/');
                            this._dialogs.error(
                                `El usuario <strong>${this._profile.user.name.fullName}</strong> no cuenta con los permisos necesarios para acceder al recurso <strong>${r.url}</strong>`
                            );
                            break;

                        default:
                            this._dialogs.error(r.message);
                            break;
                    }
                }

                if (handler.finally) {
                    handler.finally();
                }
            },
        };
    }
}
